(ns app.front.view.admin.migration.correct-cr-work-type-category
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/correct-work-type-category-in-imported-cr
    :title     "Correct work-type category in imported CRs"
    :help-text (str "Finds registered trades of imported (legacy-permit) contractor registrations whose "
                    "work-type was placed under the renew-registration category and repoints them to the "
                    "matching work-type under the sibling new-registration category. Trades with an ambiguous "
                    "match are skipped and logged. Contractor registrations must be re-indexed after this completes.")}
   match])

(def route
  {:name        :view/admin.migration.correct-cr-work-type-category
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/correct-work-type-category-in-imported-cr]))}]})
